import Swiper from 'swiper'
import { Navigation, EffectFade } from 'swiper/modules'

const swiperCarousel = document.querySelectorAll('.swiper-carousel-timeline')

function initSwiperCarousel() {
    if (!swiperCarousel.length) return

    swiperCarousel.forEach((mainSwiperEl) => {
        const timelineWrapper = mainSwiperEl.previousElementSibling
        const timelineTrack = timelineWrapper.querySelector('.timeline-track')
        const timelineItems = timelineWrapper.querySelectorAll('.timeline-item')
        const progressBar = timelineWrapper.querySelector('.timeline-progress')
        const timelineLine = timelineWrapper.querySelector('.timeline-line')
        const prevBtn = timelineWrapper.querySelector('.timeline-nav-prev')
        const nextBtn = timelineWrapper.querySelector('.timeline-nav-next')
        
        // Initialize timeline line on load
        function initTimelineLine() {
            if (timelineItems.length > 1 && timelineLine) {
                const firstDot = timelineItems[0].querySelector('.timeline-dot')
                const lastDot = timelineItems[timelineItems.length - 1].querySelector('.timeline-dot')
                const firstItem = timelineItems[0]
                const lastItem = timelineItems[timelineItems.length - 1]
                
                if (firstDot && lastDot) {
                    // Timeline line is now in timeline-track, so offsetLeft works perfectly
                    const firstDotCenter = firstItem.offsetLeft + firstDot.offsetWidth / 2
                    const lastDotCenter = lastItem.offsetLeft + lastDot.offsetWidth / 2
                    
                    timelineLine.style.left = `${firstDotCenter}px`
                    timelineLine.style.width = `${lastDotCenter - firstDotCenter}px`
                }
            }
        }
        
        // Initialize period lines
        function initPeriodLines() {
            timelineItems.forEach((item, index) => {
                const periodStart = item.dataset.periodStart
                const periodSpans = parseInt(item.dataset.periodSpans)
                
                if (periodStart && periodSpans > 1) {
                    const periodLine = item.querySelector('.period-line-connector')
                    const periodText = item.querySelector('.period-text')
                    const bracketLeft = item.querySelector('.period-bracket-left')
                    const bracketRight = item.querySelector('.period-bracket-right')
                    const endIndex = index + periodSpans - 1
                    
                    if (periodLine && timelineItems[endIndex]) {
                        const startDot = item.querySelector('.timeline-dot')
                        const endItem = timelineItems[endIndex]
                        const endDot = endItem.querySelector('.timeline-dot')
                        
                        if (startDot && endDot) {
                            // Calculate from center of first dot to center of last dot
                            const startCenter = startDot.offsetWidth / 2
                            const endCenter = endItem.offsetLeft - item.offsetLeft + endDot.offsetWidth / 2
                            const lineWidth = endCenter - startCenter
                            
                            // Position period line
                            periodLine.style.left = `${startCenter}px`
                            periodLine.style.width = `${lineWidth}px`
                            
                            // Position left bracket at start
                            if (bracketLeft) {
                                bracketLeft.style.left = `${startCenter}px`
                            }
                            
                            // Position right bracket at end
                            if (bracketRight) {
                                bracketRight.style.left = `${endCenter}px`
                            }
                            
                            // Position period text at center of the line
                            if (periodText) {
                                periodText.style.left = `${startCenter + lineWidth / 2}px`
                            }
                        }
                    }
                }
            })
        }
        
        // Run on load and resize
        setTimeout(() => {
            initTimelineLine()
            initPeriodLines()
        }, 100)
        window.addEventListener('resize', () => {
            initTimelineLine()
            initPeriodLines()
        })

        // Main content swiper
        const mainSwiper = new Swiper(mainSwiperEl, {
            modules: [Navigation, EffectFade],
            effect: 'fade',
            speed: 600,
            allowTouchMove: false, 
            simulateTouch: false,
            followFinger: false, 
            spaceBetween: 16,
            fadeEffect: {
                crossFade: true
            },
        
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            breakpoints: {
                768: {
                    spaceBetween: 0,
                },
            },
            on: {
                init: function () {
                    updateTimeline(this)
                },
                slideChange: function () {
                    updateTimeline(this)
                },
            },
        })

        // Click on timeline items
        timelineItems.forEach((item, index) => {
            item.addEventListener('click', () => {
                mainSwiper.slideTo(index)
            })
        })

        // Scroll timeline to active item
        function scrollTimelineToActive(index) {
            if (!timelineTrack || !timelineItems[index]) return

            const activeItem = timelineItems[index]
            const trackWidth = timelineTrack.offsetWidth
            const itemOffset = activeItem.offsetLeft
            const itemWidth = activeItem.offsetWidth

            // Center the active item in the visible area
            const scrollPosition = itemOffset - trackWidth / 2 + itemWidth / 2

            timelineTrack.scrollTo({
                left: scrollPosition,
                behavior: 'smooth',
            })
        }

        // Update timeline visuals and scroll
        function updateTimeline(swiperInstance) {
            const totalSlides = swiperInstance.slides.length
            const activeIndex = swiperInstance.activeIndex

            // Update progress bar (now it scrolls with dots, so no timing issues)
            if (timelineItems.length > 0) {
                const firstDot = timelineItems[0].querySelector('.timeline-dot')
                const activeDot = timelineItems[activeIndex]?.querySelector('.timeline-dot')
                
                if (firstDot && activeDot) {
                    const firstItem = timelineItems[0]
                    const activeItem = timelineItems[activeIndex]
                    
                    // Progress bar is now in timeline-track, so offsetLeft works perfectly
                    const firstDotCenter = firstItem.offsetLeft + firstDot.offsetWidth / 2
                    const activeDotCenter = activeItem.offsetLeft + activeDot.offsetWidth / 2
                    
                    // Set progress bar from first dot center to active dot center
                    if (progressBar) {
                        progressBar.style.left = `${firstDotCenter}px`
                        progressBar.style.width = `${Math.max(0, activeDotCenter - firstDotCenter)}px`
                    }
                }
            }
            
            // Scroll to active item
            scrollTimelineToActive(activeIndex)

            // Update dots and years
            timelineItems.forEach((item, index) => {
                const dot = item.querySelector('.timeline-dot')
                const year = item.querySelector('.timeline-year')

                if (index === activeIndex) {
                    // Active state - red och större
                    dot.classList.remove('bg-gray-300')
                    dot.classList.add('bg-red', 'scale-125')
                    if (year) {
                        year.classList.remove('text-gray-400')
                        year.classList.add('text-inherit')
                    }
                } else {
            
                    dot.classList.remove('bg-red', 'scale-125')
                    dot.classList.add('bg-gray-300')
                    if (year) {
                        year.classList.remove('text-inherit')
                        year.classList.add('text-gray-400')
                    }
                }
            })
        }
    })
}

initSwiperCarousel()
